import React from 'react'
import { Field } from 'redux-form'
import moment from 'moment'
import _ from 'common-tools/LodashHelper'
import styles from './WeekCalendarDateRangeBox.less'

class WeekCalendarDateRangeBoxClass extends React.Component {
  constructor (props) {
    super(props)
    this.state = { Selection: 'Week', isLocallyLoading: false }
  }

  static defaultProps = {
    showTime: false
  }

  componentDidUpdate (prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.setState({ isLocallyLoading: false })
    }
  }

  onDateChange (date) {
    const { input: { onChange } } = this.props
    let ret = []
    let startDate = (Array.isArray(date) && date[0]) ? moment(date[0]) : moment().startOf('month')
    let endDate = (Array.isArray(date) && date[1]) ? moment(date[1]) : moment().endOf('month')

    if (startDate.isValid()) {
      ret.push(startDate.startOf('day').format())
    } else {
      ret.push(moment().startOf('month').startOf('day').format())
    }

    if (endDate.isValid()) {
      ret.push(endDate.endOf('day').format())
    } else {
      ret.push(moment().endOf('month').endOf('day').format())
    }

    onChange(ret)
  }

  onFind (d) {
    const { Submit, loading } = this.props
    if (this.state.isLocallyLoading || loading) return

    let targetDate = null
    const lower = (d || '').toLowerCase()

    if (lower === 'pay period') {
      if (Array.isArray(this.props.CurrentPayPeriod) && this.props.CurrentPayPeriod.length >= 2 && this.props.CurrentPayPeriod[0]) {
        targetDate = this.props.CurrentPayPeriod
      } else {
        targetDate = [moment().startOf('month'), moment().endOf('month')]
      }
    } else if (lower === 'submit time') {
      targetDate = this.props.PreviousPayPeriod
    } else {
      targetDate = [moment().startOf(d), moment().endOf(d)]
    }

    this.setState({
      Selection: d.charAt(0).toUpperCase() + d.substr(1),
      isLocallyLoading: true
    })

    Submit(d)
    this.onDateChange(targetDate)

    setTimeout(() => {
      this.setState({ isLocallyLoading: false })
    }, 1200)
  }

  render () {
    const { Selection, isLocallyLoading } = this.state
    const { loading = false } = this.props
    const isBusy = isLocallyLoading || loading

    const selLower = (Selection || '').toLowerCase()

    const isWeek = selLower === 'week'
    const isPayPeriod = selLower === 'pay period'
    const isMonth = selLower === 'month'

    return (
      <div className={styles.buttonGroupContainer}>
        <button
          type="button"
          disabled={isBusy}
          className={`${styles.filterBtn} ${styles.btnWeek} ${isWeek ? styles.btnWeekActive : ''} ${isBusy ? styles.disabledBtn : ''}`}
          onClick={() => this.onFind('week')}
        >
          <i className={isBusy && isWeek ? 'fas fa-spinner fa-spin' : 'far fa-calendar'} /> Week
        </button>
        <button
          type="button"
          disabled={isBusy}
          className={`${styles.filterBtn} ${styles.btnPayPeriod} ${isPayPeriod ? styles.btnPayPeriodActive : ''} ${isBusy ? styles.btnPayPeriodActive : ''}`}
          onClick={() => this.onFind('pay Period')}
        >
          <i className={isBusy && isPayPeriod ? 'fas fa-spinner fa-spin' : 'far fa-calendar-alt'} /> Pay Period
        </button>
        <button
          type="button"
          disabled={isBusy}
          className={`${styles.filterBtn} ${styles.btnMonth} ${isMonth ? styles.btnMonthActive : ''} ${isBusy ? styles.disabledBtn : ''}`}
          onClick={() => this.onFind('month')}
        >
          <i className={isBusy && isMonth ? 'fas fa-spinner fa-spin' : 'far fa-calendar-check'} /> Month
        </button>
      </div>
    )
  }
}

export const WeekCalendarDateRangeBox = (props) => { return <Field name={props.name} {...props} component={WeekCalendarDateRangeBoxClass} /> } // eslint-disable-line
export default WeekCalendarDateRangeBox
